import { DataTableRequest, IDataTablesResponse, IDictionary, ReadonlyCollection } from "@ioip/core/lib";
import { JSEngine } from "../../forms/types/JSEngine";
import { PermissionLevel } from "../../studio-types";
import Entity from "./Entity";
import { EntityViewColumn } from "./EntityViewColumn";
import { IEntityViewSchema } from "./IEntityViewSchema";

export interface IEntityViewProps {
    engine: JSEngine;
    entity: Entity;
    schema: IEntityViewSchema;
}

export class EntityView {

    #props: IEntityViewProps;
    #columns: ReadonlyCollection<EntityViewColumn>;

    constructor(props: IEntityViewProps) {
        this.#props = props;
        const columns = props.schema.columns?.map(x => new EntityViewColumn({ entity: props.entity, schema: x })) ?? []
        this.#columns = new ReadonlyCollection(columns);
    }

    get id(): string {
        return this.#props.schema.id;
    }

    get name(): string {
        return this.#props.schema.name;
    }

    get description(): string {
        return this.#props.schema.description;
    }

    get columns(): ReadonlyCollection<EntityViewColumn> {
        return this.#columns;
    }

    get hasPrimaryKey(): boolean {
        return this.columns.any(x => x.attribute.isPrimaryKey)
    }

    get iconName(): string {
        return this.#props.schema.iconName;
    }

    get entity(): Entity {
        return this.#props.entity;
    }

    async paginateAsync(request: DataTableRequest): Promise<IDataTablesResponse<any>> {
        const entityId = this.#props.entity.objectId;
        const viewId = this.#props.schema.id;
        const result = this.#props.engine.paginateEntityViewAsync(entityId, viewId, request);
        return result
    }

    /**
     * Actualiza un registro de una entidad
     * @param values 
     * @returns 
     */
    async updateItemAsync(values: IDictionary<any>) {
        const primaryKeyValue = Number(values[ this.entity.primaryKey.id.toString() ]) || 0;
        //        return this.#props.engine.api.updateEntityItemAsync(this.id, this.id, primaryKeyValue, values);
        return null as any;
    }

    /**
     * Crear un registro de una entidad
     * @param values 
     * @returns 
     */
    async createItemAsync(values: IDictionary<any>) {
        // const primaryKeyValue = Number(values[ this.entity.primaryKey.id.toString() ]) || 0;
        // return this.#props.engine.api.updateEntityItemAsync(this.id, this.id, primaryKeyValue, values);
        return null as any;
    }

}
